module.exports = __webpack_public_path__ + "img/aaaa2_sample.dedb4b81.png";